// extracted by mini-css-extract-plugin
export default {"monthSection":"month-section_monthSection__a38Oy","monthSection__title":"month-section_monthSection__title__8Y41p"};